import { AppShell } from "@/components/AppShell";
import { DesktopAppDownload } from "@/components/DesktopAppDownload";
import { FullWidthToggle } from "@/components/FullWidthToggle";
import { useCurrentUser, userIsBuero } from "@/lib/auth";
import { isElectronRuntime } from "@/lib/electron";

export function MeineEinstellungenPage() {
  const { user } = useCurrentUser();
  const showDesktopDownload = userIsBuero(user) && !isElectronRuntime();

  return (
    <AppShell
      title="Persönliche Einstellungen"
      subtitle="Darstellung und Layout nach deinen Vorlieben anpassen."
      back={{ to: "/personal/me", label: "Mein Bereich" }}
    >
      <div className="space-y-4">
        <section className="rounded-ios border border-separator bg-card shadow-ios">
          <header className="border-b border-separator px-5 py-4">
            <h2 className="text-base font-semibold text-label">Darstellung</h2>
            <p className="mt-1 text-sm text-label-secondary">
              Steuere, wie Inhalte in der App angezeigt werden. Denselben Schalter findest du auch im
              Profilmenü unter „Neues Design“.
            </p>
          </header>

          <div className="divide-y divide-separator">
            <FullWidthToggle variant="settings" />
          </div>
        </section>

        {showDesktopDownload ? (
          <section className="rounded-ios border border-separator bg-card shadow-ios">
            <header className="border-b border-separator px-5 py-4">
              <h2 className="text-base font-semibold text-label">Desktop-App</h2>
              <p className="mt-1 text-sm text-label-secondary">
                Für den Windows-PC – mit lokalen Ordnern und automatischen Updates.
              </p>
            </header>
            <DesktopAppDownload user={user} variant="settings" />
          </section>
        ) : null}
      </div>
    </AppShell>
  );
}
